"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var summaryElement = function summaryElement(Component, stepId) {
  return function (props) {
    return _react2.default.createElement("div", null, _react2.default.createElement(Component, props), _react2.default.createElement("a", {
      className: "link ico undo",
      onClick: function onClick() {
        return props.goToStep(stepId);
      }
    }, "\xE4ndern"));
  };
};

exports.default = summaryElement;